import {
  DOCTYPE_SHORTCUT,
  DOCTYPE_SHORTCUT_GROUP,
} from '@krispsystems/constants';

import * as util from '../apiUtils';
import * as common from '../apiCommon';

export function fetchShortcut(app, params) {
  const { id } = params;
  const docType = DOCTYPE_SHORTCUT;
  return common.getDoc(app, { id, docType });
}

export function deleteShortcut(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DOCTYPE_SHORTCUT,
  });
}

export function saveShortcut(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const doc = {
    active: util.toBoolean(data.active),
    doc_type: DOCTYPE_SHORTCUT,
    embedded: util.toBoolean(data.embedded),
    name: util.toStringText(data.name),
    type: util.toStringText(data.type),
    value: util.toStringText(data.value),
    before_open: util.toStringText(data.before_open),
  };

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}

export async function fetchShortcutGroup(app, params) {
  const { id } = params;
  const docType = DOCTYPE_SHORTCUT_GROUP;
  const shortcutGroup = await common.getDoc(app, { id, docType });
  return shortcutGroup;
}

export function deleteShortcutGroup(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DOCTYPE_SHORTCUT_GROUP,
  });
}

export function saveShortcutGroup(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const { shortcuts } = data;

  const doc = {
    active: util.toBoolean(data.active),
    doc_type: DOCTYPE_SHORTCUT_GROUP,
    name: util.toStringText(data.name),
  };

  if (Array.isArray(shortcuts)) {
    doc.shortcuts = shortcuts.map((shortcut, s) => ({
      ...shortcut,
      shortcut_shortcut_group: { index: s },
    }));
  }

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}

export function fetchShortcutDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'shortcut/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function fetchShortcutGroupDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'shortcut_group/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}
